import React, { useEffect, useRef, useState } from "react"
import LeftIcon from "../../images/LeftIcon"
import DatePicker from "react-datepicker";
import { webLoadingFalse, webLoadingTrue, webNavigate } from "../../services/navigate.service"
import { validateNoSpecialChars, validatePhoneNumber } from "../../validation/ValidationInput"
import ArrowClientsIcon from "../../images/ArrowClientsIcon"
import { getCountries } from "../../services/country.service";
import { createEmploy, getDetailsEmploy, updateDetailsEmploy } from "../../services/employ.service";
import PopupLocation from "../../components/PopupLocation";
import BankIcon from "../../images/BankIcon";
import ProfessionIcon from "../../images/ProfessionIcon";
import ContactIcon from "../../images/ContactIcon";
import { showToast } from "../../services/toast.service";
import { showApiError } from "../../services/apiError";
import { coreFormLimits, limitProps, useFieldLimits, validateAgainstLimits } from "../../services/fieldLimits";
import FieldCounter from "../../components/FieldCounter";
import BackIcon from "../../images/BackIcon";
import CheckIcon from "../../images/CheckIcon";
import { DropdownSearch } from "../../components/DropdownSearch";
import { useResponsive } from "../../hook/useResponsive";
import { useFormKeyboard } from "../../hook/useFormKeyboard";
interface InforTable {
    title: string;
    path: string;
    desc: string;
    titleCreate: string;
}

interface Country {
    id: string;
    code: string;
    name: string;
}

// The step showing each field, so a save error can jump to it.
const EMPLOYEE_FIELD_STEPS: Record<string, number> = {
    employeeCode: 1, firstName: 1, lastName: 1, emailAddress: 1, phoneNumber: 1, nationalNo: 1, countryId: 1,
    education: 2, profession: 2, position: 2,
    bankName: 3, accountNo: 3, employeeNo: 3,
};

const CreateEmployees = () => {
    const [formValues, setFormValues] = useState<any>({
        firstName: '',
        lastName: '',
    });
    const [language, setLanguage] = useState<any>(null);
    const { isMobile, getWidth } = useResponsive();
    const preLanguage = localStorage.getItem("language");
    const [tab, setTab] = useState<string>("profile");
    const [startDate, setStartDate] = useState(new Date());
    const [dateOfBirth, setDateOfBirth] = useState(new Date());
    const [contractExpiration, setContractExpiration] = useState(new Date());
    const [step, setStep] = useState<number>(1)
    const [clientsArray, setClientsArray] = useState<any>({
        count: 0,
        data: []
    });
    const [filter, setFilter] = useState<any>({
        page: 1,
        limit: 50,
        sort: "DESC"
    })
    const [countries, setCountries] = useState<Country[]>([]);
    const [errors, setErrors] = useState<any>({});
    const limits = useFieldLimits(coreFormLimits("employee"));
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const [searchCountry, setSearchCountry] = useState("");
    const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
    const dropdownCountryRef = useRef<HTMLDivElement>(null);
    const dropdownGenderRef = useRef<HTMLDivElement>(null);
    const dropdownTermRef = useRef<HTMLDivElement>(null);
    const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
    const calculatedWidth = (windowWidth / 1290);
    const inforTable: InforTable = {
        title: "No Employees Found", path: "/" + preLanguage + "/employees/new", desc: "Add a new employee to manage your team here.", titleCreate: "New Employee"
    }
    const path = window.location.pathname;
    const id: string = path.split('/').pop() || "";
    const kb = useFormKeyboard({ step, autoFocus: id === 'new' && !isMobile });

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    useEffect(() => {
        if (window.languageContext) {
            setLanguage(window.languageContext.language);
        }
    }, [window, window.languageContext]);
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownCountryRef.current && !dropdownCountryRef.current.contains(event.target as Node)) {
                setIsCountryDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    useEffect(() => {
        if (id !== "new") {
            fetchData(id);
        }
        const handleNewToken = () => {
            if (id !== "new") {
                fetchData(id);
            }
        };
        document.addEventListener("newToken", handleNewToken);
        return () => {
            document.removeEventListener("newToken", handleNewToken);
        };
    }, [path]);
    const fetchData = async (id: string) => {
        webLoadingTrue();
        try {
            const response: any = await getDetailsEmploy(id);
            console.log("🚀 ~ fetchData ~ response:", response)
            setFormValues(response.data);
            setSearchCountry(response.data.country.countryName);
            setDateOfBirth(new Date(response.data.dob))
            setStartDate(new Date(response.data.startDate));
            setContractExpiration(new Date(response.data.endDate));
            setClientsArray(new Date(response.data.endDate));
        } catch (error) {
            console.error("Error loading terms:", error);
        } finally {
            webLoadingFalse();
        }
    };
    useEffect(() => {
        const fetchCountries = async () => {
            const data = await getCountries();
            setCountries(data);
        };
        fetchCountries();
        const handleNewToken = () => {
            fetchCountries();
        };
        document.addEventListener("newToken", handleNewToken);
        return () => {
            document.removeEventListener("newToken", handleNewToken);
        };
    }, []);

    const handleStartDate = (value: any) => {
        setStartDate(value);
        setFormValues({ ...formValues, startDate: value });
    };
    const handleStartOfBirth = (value: any) => {
        setDateOfBirth(value);
        setFormValues({ ...formValues, dob: value });
    };

    const handleContractExpiration = (value: any) => {
        setContractExpiration(value);
        setFormValues({ ...formValues, endDate: value });
    };

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const { name, value, type } = e.target;
        setFormValues({ ...formValues, [name]: value })
    }

    const handleCountrySelect = (country: any) => {
        setFormValues((prev: any) => ({ ...prev, countryId: country.id }));
        setSearchCountry(country.name);
        setIsCountryDropdownOpen(false);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
    };
    const handleOpenPopup = () => {
        setShowPopup(true);
    };
    const handleSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        const newErrors: any = validateAgainstLimits(formValues, limits, language);
        if (!formValues.firstName) {
            newErrors.firstName = 'First Name is required';
        }
        if (!formValues.lastName) {
            newErrors.lastName = 'Last Name is required';
        }
        if (!formValues.countryId) {
            newErrors.countryId = 'Country is required';
        }
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStep(Math.min(...Object.keys(newErrors).map((field) => EMPLOYEE_FIELD_STEPS[field] ?? step)));
            return;
        }
        webLoadingTrue();
        const payload = {
            ...formValues,
            startDate: formValues?.startDate ? formValues?.startDate : new Date(),
            endDate: formValues?.endDate ? formValues?.endDate : new Date(),
        }
        if (id === "new") {
            try {
                const response = await createEmploy(payload);
                if (response?.data?.id) {
                    webNavigate("/" + preLanguage + "/employees");
                    webLoadingFalse();
                    showToast({
                        message: "Employees Created !",
                        type: 'success',
                        duration: 20000,
                    });
                }
            } catch (error: any) {
                webLoadingFalse();

                showApiError(error, { language, setFieldErrors: setErrors, fieldSteps: EMPLOYEE_FIELD_STEPS, onStep: setStep });
            }
        } else {
            try {
                const response = await updateDetailsEmploy(id, payload);
                if (response?.data?.id) {
                    webNavigate("/" + preLanguage + "/employees");
                    webLoadingFalse();
                    showToast({
                        message: "Employees Updated !",
                        type: 'success',
                        duration: 20000,
                    });
                }
            } catch (error: any) {
                webLoadingFalse();

                showApiError(error, { language, setFieldErrors: setErrors, fieldSteps: EMPLOYEE_FIELD_STEPS, onStep: setStep });
            }
        }
    }

    const handleReceivePageNumber = (pageNumber: number) => {
        setFilter({ ...filter, page: pageNumber })
    }

    return (
        <div {...kb.scopeProps}>
            <div className=" bg-white">
                <div className="flex items-center ">
                    <button
                        type="button"
                        key={step === 1 ? 'exit' : 'back'}
                        aria-label={language?.['Back'] ?? 'Back'}
                        className="w-6 h-6 flex items-center justify-center cursor-pointer"
                        onClick={() => {
                            step === 1
                                ? webNavigate('/' + preLanguage + '/employees')
                                : step === 2
                                    ? setStep(1)
                                    : setStep(2);
                        }}
                    >
                        <BackIcon />
                    </button>
                    <p
                        style={{ fontSize: '14px', fontWeight: '500', lineHeight: '28px', color: '#222525' }}
                        className="font-inter"
                    >
                        {language && language?.['Back'] ? language?.['Back'] : 'Back'}
                    </p>
                </div>
            </div>
            {id === 'new' ? (
                <p
                    style={{
                        margin: '20px 0px',
                        fontSize: '20px',
                        fontWeight: '500',
                        lineHeight: '28px',
                        color: '#222525',
                    }}
                    className="font-inter"
                >
                    {language && language?.['Add Employee']
                        ? language?.['Add Employee']
                        : 'Add Employee'}
                </p>
            ) : (
                <p
                    style={{
                        margin: '20px 0px',
                        fontSize: '20px',
                        fontWeight: '500',
                        lineHeight: '28px',
                        color: '#222525',
                    }}
                    className="font-inter"
                >
                    {language && language?.['Edit Employee']
                        ? language?.['Edit Employee']
                        : 'Edit Employee'}
                </p>
            )}
            <div className="flex items-start lg:items-center" style={{ gap: isMobile ? '10px' : '20px', marginTop: isMobile ? '2px' : '0' }}>
                <div className="" style={{ width: isMobile ? 'calc(33.333% - 7px)' : 'calc(33% - 10px)' }}>
                    <div
                        className=""
                        style={{
                            minHeight: '4px',
                            width: "100%",
                            backgroundColor: (step === 1 || step === 2 || step === 3) ? '#0F7679' : '#DBE4E4',
                            borderRadius: '20px',
                        }}
                    ></div>
                    <div className="" style={{ marginTop: isMobile ? "6px" : "12px" }}>
                        <div className="flex items-center" style={{ gap: '8px' }}>
                            {step === 2 && (
                                <div
                                    className="flex items-center justify-center"
                                    style={{ width: '20px', height: '20px' }}
                                >
                                    <CheckIcon />
                                </div>
                            )}
                            <p
                                className="text-[14px] font-inter leading-[20px] font-medium"
                                style={{ color: '#0F7679' }}
                            >
                                {language && language?.['Step 1'] ? language?.['Step 1'] : 'Step 1'}
                            </p>
                        </div>
                        <p
                            className="text-[14px] font-inter leading-[20px] font-medium"
                            style={{ color: '#05292A' }}
                        >
                            {language && language?.['Personal details'] ? language?.['Personal details'] : 'Personal details'}
                        </p>
                    </div>
                </div>
                <div className="" style={{ width: isMobile ? 'calc(33.333% - 7px)' : 'calc(33% - 10px)' }}>
                    <div
                        className=""
                        style={{
                            minHeight: '4px',
                            width: "100%",
                            backgroundColor: (step === 2 || step === 3) ? '#0F7679' : '#DBE4E4',
                            borderRadius: '20px',
                        }}
                    ></div>
                    <div className="" style={{ marginTop: isMobile ? "6px" : "12px" }}>
                        <div className="flex items-center">
                            <p
                                className="text-[14px] font-inter leading-[20px] font-medium"
                                style={{ color: (step === 2 || step === 3) ? '#0F7679' : '#819596' }}
                            >
                                {language && language?.['Step 2'] ? language?.['Step 2'] : 'Step 2'}
                            </p>
                        </div>
                        <p
                            className="text-[14px] font-inter leading-[20px] font-medium"
                            style={{ color: '#05292A' }}
                        >
                            {language && language?.['Professional details']
                                ? language?.['Professional details']
                                : 'Professional details'}
                        </p>
                    </div>
                </div>
                <div className="" style={{ width: isMobile ? 'calc(33.333% - 7px)' : 'calc(33% - 10px)' }}>
                    <div
                        className=""
                        style={{
                            minHeight: '4px',
                            width: "100%",
                            backgroundColor: step === 3 ? '#0F7679' : '#DBE4E4',
                            borderRadius: '20px',
                        }}
                    ></div>
                    <div className="" style={{ marginTop: isMobile ? "6px" : "12px" }}>
                        <div className="flex items-center">
                            <p
                                className="text-[14px] font-inter leading-[20px] font-medium"
                                style={{ color: (step === 3) ? '#0F7679' : '#819596' }}
                            >
                                {language && language?.['Step 3'] ? language?.['Step 3'] : 'Step 3'}
                            </p>
                        </div>
                        <p
                            className="text-[14px] font-inter leading-[20px] font-medium"
                            style={{ color: '#05292A' }}
                        >
                            {language && language?.['Bank & Contract details']
                                ? language?.['Bank & Contract details']
                                : 'Bank & Contract details'}
                        </p>
                    </div>
                </div>
            </div>
            <form className="scroll-container"
                style={{ height: isMobile ? 'calc(100% - 283px)' : 'calc(100% - 235px)', marginTop: '20px', paddingBottom: isMobile ? '24px' : '0px' }}
            >
                <div className="" style={{ width: "100%" }}>
                    {
                        step === 1 &&
                        <div>
                            <div className="space-y-2">
                                <div className="flex items-center">
                                    <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: '500' }}>{language && language?.["Code"] ? language?.["Code"] : "Code"}</p>
                                    <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                                        {language && language?.['*'] ? language?.['*'] : '*'}
                                    </p>
                                </div>
                                <div className="w-full">
                                    <input
                                        value={formValues?.employeeCode}
                                        name="employeeCode"
                                        {...limitProps(limits, "employeeCode")}
                                        onChange={(e: any) => {
                                            handleChange(e)
                                        }}
                                        className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                    />
                                    <FieldCounter value={formValues?.employeeCode} max={limits.employeeCode?.maxLength} />
                                </div>
                                {errors.employeeCode && <p className="error">{errors.employeeCode}</p>}
                            </div>
                            <div className="flex items-center" style={{ gap: "12px" }}>
                                <div className="space-y-2" style={{ marginTop: "20px", width: "50%" }}>
                                    <div className="flex items-center">
                                        <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: '500' }}>{language && language?.["First Name"] ? language?.["First Name"] : "First Name"}</p>
                                        <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                                            {language && language?.['*'] ? language?.['*'] : '*'}
                                        </p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            type="text"
                                            name="firstName"
                                            {...limitProps(limits, "firstName")}
                                            value={formValues?.firstName}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                        <FieldCounter value={formValues?.firstName} max={limits.firstName?.maxLength} />
                                    </div>
                                    {errors.firstName && <p className="error">{errors.firstName}</p>}
                                </div>
                                <div className="space-y-2" style={{ marginTop: "20px", width: "50%" }}>
                                    <div className="flex items-center">
                                        <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: '500' }}>{language && language?.["Last Name"] ? language?.["Last Name"] : "Last Name"}</p>
                                        <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                                            {language && language?.['*'] ? language?.['*'] : '*'}
                                        </p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            type="text"
                                            name="lastName"
                                            {...limitProps(limits, "lastName")}
                                            value={formValues?.lastName}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                        <FieldCounter value={formValues?.lastName} max={limits.lastName?.maxLength} />
                                    </div>
                                    {errors.lastName && <p className="error">{errors.lastName}</p>}
                                </div>
                            </div>
                            <div className="flex items-center" style={{ gap: "24px", flexWrap: 'wrap' }}>
                                <div className="space-y-2" style={{ marginTop: "20px", width: isMobile ? '100%' : 'calc(33% - 12px)' }}>
                                    <div className="flex items-center justify-between">
                                        <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: '500' }}>{language && language?.["Date of birth"] ? language?.["Date of birth"] : "Date of birth"}</p>
                                    </div>
                                    <div className="w-full">
                                        <DatePicker
                                            showTimeSelect
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText={language && language?.["Enter employee’s date of birth"] ? language?.["Enter employee’s date of birth"] : "Enter employee’s date of birth"}
                                            name="startTime"
                                            className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full"
                                            selected={dateOfBirth}
                                            onChange={(e) => handleStartOfBirth(e)}
                                        />
                                    </div>
                                </div>
                                <div className="space-y-2" style={{ marginTop: "20px", width: isMobile ? '100%' : 'calc(33% - 12px)' }}>
                                    <div className="flex items-center justify-between">
                                        <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: '500' }}>{language && language?.["Email"] ? language?.["Email"] : "Email"}</p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            type="text"
                                            name="emailAddress"
                                            {...limitProps(limits, "emailAddress")}
                                            // onKeyDown={validateEmail}
                                            value={formValues?.emailAddress}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                        <FieldCounter value={formValues?.emailAddress} max={limits.emailAddress?.maxLength} />
                                    </div>
                                    {errors.emailAddress && <p className="error">{errors.emailAddress}</p>}
                                </div>
                                <div style={{ marginTop: "20px", width: isMobile ? '100%' : 'calc(33% - 12px)' }} className="space-y-2">
                                    <div className="flex items-center justify-between">
                                        <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: '500' }}>{language && language?.["Phone Number"] ? language?.["Phone Number"] : "Phone Number"}</p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            type="text"
                                            name="phoneNumber"
                                            {...limitProps(limits, "phoneNumber")}
                                            value={formValues?.phoneNumber}
                                            onKeyDown={validatePhoneNumber}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                        <FieldCounter value={formValues?.phoneNumber} max={limits.phoneNumber?.maxLength} />
                                    </div>
                                    {errors.phoneNumber && <p className="error">{errors.phoneNumber}</p>}
                                </div>
                            </div>
                            <div className="flex items-center" style={{ gap: "24px", flexWrap: 'wrap' }}>
                                <div style={{ marginTop: "20px", width: isMobile ? "100%" : 'calc(50% - 12px)' }} className="space-y-2">
                                    <div className="flex items-center justify-between">
                                        <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: '500' }}>{language && language?.["National ID no"] ? language?.["National ID no"] : "National ID no"}</p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            value={formValues?.nationalNo}
                                            name="nationalNo"
                                            {...limitProps(limits, "nationalNo")}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                        <FieldCounter value={formValues?.nationalNo} max={limits.nationalNo?.maxLength} />
                                    </div>
                                    {errors.nationalNo && <p className="error">{errors.nationalNo}</p>}
                                </div>
                                <div className="w-full space-y-2" style={{ marginTop: "20px", width: isMobile ? "100%" : 'calc(50% - 12px)' }}>
                                    <div className="flex items-center">
                                        <p className="text-[14px] font-inter leading-[20px]">{language && language?.["Country"] ? language?.["Country"] : "Country"}</p>
                                        <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                                            {language && language?.['*'] ? language?.['*'] : '*'}
                                        </p>
                                    </div>
                                    <div className="w-full">
                                        <DropdownSearch
                                            refKey="type"
                                            refs={{ type: dropdownCountryRef }}
                                            openStates={{ type: isCountryDropdownOpen }}
                                            open={(key) => key === "type" && setIsCountryDropdownOpen(true)}
                                            close={(key) => key === "type" && setIsCountryDropdownOpen(false)}
                                            data={countries}
                                            labelExtractor={(item) => item.name}
                                            value={searchCountry}
                                            setValue={setSearchCountry}
                                            onSelect={handleCountrySelect}
                                            error={errors.countryId}
                                            borderNone={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {step === 2 &&
                        <div className="flex items-center" style={{ gap: '20px', flexWrap: 'wrap' }}>
                            <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(33% - 10px)' }} >
                                <div className="flex items-center justify-between">
                                    <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: '500' }}>{language && language?.["Education Degree"] ? language?.["Education Degree"] : "Education Degree"}</p>
                                </div>
                                <div className="w-full">
                                    <input
                                        value={formValues?.education}
                                        name="education"
                                        {...limitProps(limits, "education")}
                                        onChange={(e: any) => {
                                            handleChange(e)
                                        }}
                                        className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                    />
                                    <FieldCounter value={formValues?.education} max={limits.education?.maxLength} />
                                </div>
                                {errors.education && <p className="error">{errors.education}</p>}
                            </div>
                            <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(33% - 10px)' }}>
                                <div className="flex items-center justify-between">
                                    <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: '500' }}>{language && language?.["Profession"] ? language?.["Profession"] : "Profession"}</p>
                                </div>
                                <div className="w-full">
                                    <input
                                        type="text"
                                        name="profession"
                                        {...limitProps(limits, "profession")}
                                        value={formValues?.profession}
                                        onChange={(e: any) => {
                                            handleChange(e)
                                        }}
                                        className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                    />
                                    <FieldCounter value={formValues?.profession} max={limits.profession?.maxLength} />
                                </div>
                                {errors.profession && <p className="error">{errors.profession}</p>}
                            </div>
                            <div style={{ width: isMobile ? '100%' : 'calc(33% - 10px)' }} className="space-y-2">
                                <div className="flex items-center justify-between">
                                    <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: '500' }}>{language && language?.["Position"] ? language?.["Position"] : "Position"}</p>
                                </div>
                                <div className="w-full">
                                    <input
                                        type="text"
                                        name="position"
                                        {...limitProps(limits, "position")}
                                        value={formValues?.position}
                                        onChange={(e: any) => {
                                            handleChange(e)
                                        }}
                                        className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                    />
                                    <FieldCounter value={formValues?.position} max={limits.position?.maxLength} />
                                </div>
                                {errors.position && <p className="error">{errors.position}</p>}
                            </div>
                        </div>
                    }
                    {
                        step === 3 &&
                        <>

                            <div>
                                <div className="flex items-center" style={{ gap: '8px' }}>
                                    <p className="font-inter" style={{ fontSize: '16px', fontWeight: "500", color: "#05292A", lineHeight: "21px" }}>{language && language?.["Bank details"] ? language?.["Bank details"] : "Bank details"}</p>
                                </div>
                                <div className="flex items-center" style={{ marginTop: '16px', gap: '20px', flexWrap: 'wrap' }}>
                                    <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(50% - 10px)' }}>
                                        <div className="flex items-center justify-between">
                                            <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: '500' }}>{language && language?.["Bank Name"] ? language?.["Bank Name"] : "Bank Name"}</p>
                                        </div>
                                        <div className="w-full">
                                            <input
                                                value={formValues?.bankName}
                                                name="bankName"
                                                {...limitProps(limits, "bankName")}
                                                onChange={(e: any) => {
                                                    handleChange(e)
                                                }}
                                                className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                            />
                                            <FieldCounter value={formValues?.bankName} max={limits.bankName?.maxLength} />
                                        </div>
                                        {errors.bankName && <p className="error">{errors.bankName}</p>}
                                    </div>
                                    <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(50% - 10px)' }}>
                                        <div className="flex items-center justify-between">
                                            <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: '500' }}>{language && language?.["Account No"] ? language?.["Account No"] : "Account No"}</p>
                                        </div>
                                        <div className="w-full">
                                            <input
                                                type="text"
                                                name="accountNo"
                                                {...limitProps(limits, "accountNo")}
                                                value={formValues?.accountNo}
                                                onChange={(e: any) => {
                                                    handleChange(e)
                                                }}
                                                className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                            />
                                            <FieldCounter value={formValues?.accountNo} max={limits.accountNo?.maxLength} />
                                        </div>
                                        {errors.accountNo && <p className="error">{errors.accountNo}</p>}
                                    </div>
                                </div>
                            </div>
                            <div style={{ marginTop: '24px' }} >
                                <div className="flex items-center" style={{ gap: '8px' }}>
                                    <p className="font-inter" style={{ fontSize: '16px', fontWeight: "500", color: "#05292A", lineHeight: "21px" }}>{language && language?.["Contract details"] ? language?.["Contract details"] : "Contract details"}</p>
                                </div>
                                <div className="flex items-center" style={{ marginTop: '16px', gap: '20px', flexWrap: 'wrap' }}>
                                    <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(33% - 10px)' }} >
                                        <div className="flex items-center justify-between">
                                            <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: '500' }}>{language && language?.["Starting Date"] ? language?.["Starting Date"] : "Starting Date"}</p>
                                        </div>
                                        <div className="w-full">
                                            <DatePicker
                                                showTimeSelect
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText={language && language?.["Enter a starting date"] ? language?.["Enter a starting date"] : "Enter a starting date"}
                                                name="startTime"
                                                className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full"
                                                selected={startDate}
                                                onChange={(e) => handleStartDate(e)}
                                            />
                                        </div>
                                    </div>
                                    <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(33% - 10px)' }}>
                                        <div className="flex items-center justify-between">
                                            <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: '500' }}>{language && language?.["Expiration Date"] ? language?.["Expiration Date"] : "Expiration Date"}</p>
                                        </div>
                                        <div className="w-full">
                                            <DatePicker
                                                showTimeSelect
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText={language && language?.["Select expiration date"] ? language?.["Select expiration date"] : "Select expiration date"}
                                                name="startTime"
                                                className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full"
                                                selected={contractExpiration}
                                                onChange={(e) => handleContractExpiration(e)}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ width: isMobile ? '100%' : 'calc(33% - 10px)' }} className="space-y-2" >
                                        <div className="flex items-center justify-between">
                                            <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: '500' }}>{language && language?.["Employee no"] ? language?.["Employee no"] : "Employee no"}</p>
                                        </div>
                                        <div className="w-full">
                                            <input
                                                value={formValues?.employeeNo}
                                                name="employeeNo"
                                                {...limitProps(limits, "employeeNo")}
                                                onChange={(e: any) => {
                                                    handleChange(e)
                                                }}
                                                className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                            />
                                            <FieldCounter value={formValues?.employeeNo} max={limits.employeeNo?.maxLength} />
                                        </div>
                                        {errors.employeeNo && <p className="error">{errors.employeeNo}</p>}
                                    </div>
                                </div>
                                {errors.idNo && <p className="error">{errors.idNo}</p>}
                            </div>
                        </>
                    }
                </div>
            </form>
            <div
                className="w-full flex items-center justify-end shadow_button relative"
                style={{ gap: "12px", paddingTop: "24px", }}
            >
                <div className="absolute" style={{ left: "-24px", top: 0, height: "1px", backgroundColor: "#DBE4E4", width: isMobile ? 'calc(100vw + 32px)' : "calc(-256px + 48px + 100vw)" }}></div>
                {/* Keyed apart too: a focused Back must not become Cancel, where one more Enter leaves. */}
                <button
                    type="button"
                    key={step === 1 ? 'cancel' : 'back'}
                    onClick={() => {
                        step === 1 ? webNavigate("/" + preLanguage + "/employees") : step === 2 ? setStep(1) : setStep(2)
                    }}
                    style={{
                        padding: '10px 20px',
                        borderRadius: '30px',
                        color: '#222525',
                        fontSize: '14px',
                        fontWeight: '500',
                        border: '1px solid #C9D7D8',
                    }}
                    className="font-inter cursor-pointer"
                >
                    {step === 1 ?
                        language && language?.['Cancel'] ? language?.['Cancel'] : 'Cancel'
                        :
                        language && language?.['Back'] ? language?.['Back'] : 'Back'
                    }
                </button>
                {/* Keyed apart so a focused Next is not reused as Save, where one more Enter would save. */}
                {step < 3 ? (
                    <button
                        type="button"
                        key="next"
                        {...kb.primaryProps(() => {
                            step === 1 ? setStep(2) : setStep(3)
                        })}
                        style={{
                            padding: '10px 20px',
                            borderRadius: '30px',
                            color: '#FFFFFF',
                            fontSize: '14px',
                            fontWeight: '500',
                            backgroundColor: '#0F7679',
                        }}
                        className="font-inter cursor-pointer"
                    >
                        {language && language?.['Next'] ? language?.['Next'] : 'Next'}
                    </button>
                ) : (
                    <button
                        type="button"
                        key="save"
                        {...kb.primaryProps(handleSubmit)}
                        style={{
                            padding: '10px 20px',
                            borderRadius: '30px',
                            color: '#FFFFFF',
                            fontSize: '14px',
                            fontWeight: '500',
                            backgroundColor: '#0F7679',
                        }}
                        className="font-inter cursor-pointer"
                    >
                        {language && language?.['Save changes'] ? language?.['Save changes'] : 'Save changes'}
                    </button>
                )}
            </div>
        </div>
    )
}
export default CreateEmployees